import { white } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { device, breakpoints, getWidthRange } from '../../../../app/js/utils/responsive_utilities';
import styled from 'styled-components';

export const VideoOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; bottom: 0; right: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100;
`;

export const ContentContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
`;

export const VideoContainer = styled.div`
  position:relative;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  height: 56.4rem;
  width: 64rem;
  text-align: center;
  visibility: ${(props) => props.isVideoReady ? 'visible' : 'hidden'};
  iframe {
    height: 100%;
    width: 100%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 77rem;
    height: 57.2rem;
  }
  @media ${getWidthRange(0, breakpoints.sm)} {
    width: 100%;
  }
  @media ${device.PhoneTabletLandscape} {
    height: 80%;
  }
`;

export const CrossBtn = styled.div`
  position: absolute;
  top: 20%;
  right: 1rem;
  transform: translateY(-50%);
  cursor: pointer;
  height: 2.2rem;
  width: 2.2rem;
  z-index: 101;

  &:before, &:after {
    position: absolute;
    left: 1rem;
    content: ' ';
    height: 2.2rem;
    width: .3rem;
    background-color: ${white};
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
  @media (min-width: ${breakpoints.lg}px) {
    top: -5%;
    right: 2%;
    width: 2.2rem;
    height: 2.2rem;
    &:before, &:after {
      height: 2.2rem;
      border-radius: .2rem;
    }
  }
  @media ${device.Tablet} {
    top: 0;
    right: 1rem;
  }
  @media ${device.PhoneTabletLandscape} {
    top: 5%;
    right: 10%;
  }
`;
